// extracted by mini-css-extract-plugin
export const container = "ShorexIcon-module--container--U5Jwa";
export const label = "ShorexIcon-module--label--2s3A-";
export const withDescription = "ShorexIcon-module--with-description--2DZ6L";
export const withLabel = "ShorexIcon-module--with-label--_iGSl";
export const withShowLabelMobile = "ShorexIcon-module--with-show-label-mobile--3-H5Q";
export const sizeBig = "ShorexIcon-module--size-big--kO6V2";
export const icon = "ShorexIcon-module--icon--1HYSU";